(() => {
  const journeys = document.querySelectorAll('[data-history-journey]');

  journeys.forEach((journey) => {
    const milestones = Array.from(journey.querySelectorAll('.about-history-journey__milestone'));
    const nodes = Array.from(journey.querySelectorAll('[data-history-node]'));
    const status = journey.querySelector('[data-history-status]');
    const prev = journey.querySelector('[data-history-prev]');
    const next = journey.querySelector('[data-history-next]');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    let activeIndex = 0;

    if (!milestones.length || !nodes.length) return;

    const formatIndex = (value) => String(value + 1).padStart(2, '0');

    const activate = (index, options = {}) => {
      activeIndex = (index + nodes.length) % nodes.length;

      milestones.forEach((milestone, milestoneIndex) => {
        milestone.classList.toggle('is-active', milestoneIndex === activeIndex);
      });

      nodes.forEach((node, nodeIndex) => {
        node.setAttribute('aria-pressed', nodeIndex === activeIndex ? 'true' : 'false');
      });

      if (status) status.textContent = formatIndex(activeIndex);

      if (options.focus) nodes[activeIndex].focus({ preventScroll: true });

      if (window.matchMedia('(max-width: 56rem)').matches && options.scroll) {
        milestones[activeIndex].scrollIntoView({
          behavior: reducedMotion.matches ? 'auto' : 'smooth',
          block: 'nearest',
          inline: 'center'
        });
      }
    };

    nodes.forEach((node, index) => {
      node.addEventListener('click', () => activate(index, { scroll: true }));

      node.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowRight' || event.key === 'ArrowDown') {
          event.preventDefault();
          activate(index + 1, { focus: true, scroll: true });
        }

        if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') {
          event.preventDefault();
          activate(index - 1, { focus: true, scroll: true });
        }

        if (event.key === 'Home') {
          event.preventDefault();
          activate(0, { focus: true, scroll: true });
        }

        if (event.key === 'End') {
          event.preventDefault();
          activate(nodes.length - 1, { focus: true, scroll: true });
        }
      });
    });

    prev?.addEventListener('click', () => activate(activeIndex - 1, { focus: true, scroll: true }));
    next?.addEventListener('click', () => activate(activeIndex + 1, { focus: true, scroll: true }));

    if ('IntersectionObserver' in window && !reducedMotion.matches) {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            journey.classList.add('is-visible');
            observer.unobserve(journey);
          }
        });
      }, { threshold: 0.22 });

      observer.observe(journey);
    } else {
      journey.classList.add('is-visible');
    }

    activate(0);
  });
})();